import CreatePalettePage from "../../../../Posts/04-tools/02-create-palette/CreatePalettePage.js";
import * as React from 'react';
export default {
  CreatePalettePage,
  React
};